module.exports = __webpack_public_path__ + "assets/leaflet.6d4b124a.svg";